import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import Table from 'rc-table';
import EtiquetaEstado from './EtiquetaEstado';

class TablaEstados extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    render() {
        let columnas = [];
        let arrayResult = [];
        let estados = {};

        for (var i = 0; i < this.props.data.estados.length; i++) {
            columnas.push({
                title: this.props.data.estados[i].EstadoNumero + ' - ' + this.props.data.estados[i].EstadoInfo.Descripcion,
                dataIndex: 'Estado' + this.props.data.estados[i].EstadoNumero,
                key: 'Estado' + this.props.data.estados[i].EstadoNumero,
                render: (record) => <EtiquetaEstado record={record} data={this.props.data} />,
                className: 'header-style-' + i,
                width: '200px'
            });

            estados['Estado' + this.props.data.estados[i].EstadoNumero] = this.props.data.estados[i];
        }

        arrayResult.push(estados);

        return (
            <div>
                <Table
                    columns={columnas}
                    data={arrayResult}
                    className="circuto-estado-tabla"
                    scroll={{ x: true }}
                />
            </div>
        );
    }
}

export default TablaEstados;
